import ToastHighLighter from '@/lib/ToastHighLighter';

export const WebdienstTemplateCode = () => {
  const language = 'html';
  const codeString = `
  // Webdienste Basic Template
  ...
  <nav class="paas navbar navbar-light navbar-expand-lg navbar-main">
    <div class="navbar-container container flex align-content-center mb-lg-3">
      <a href="/" class="navbar-brand">
        <img
          src=""
          alt=""
          height=""
          width=""
        />
      </a>

      <button
        class="navbar-toggler position-absolute end-0"
        type="button"
        data-bs-toggle="collapse"
        data-bs-target="#navbarTogglerDemo03"
        aria-controls="navbarNav"
        aria-expanded="false"
        aria-label="Toggle navigation"
      >
        <span class="navbar-toggler-icon"></span> Menü
      </button>

      <div class="d-lg-flex align-items-center d-none mr-3 meta-nav-wrapper">
        <ul class="nav lang-nav">
          <li>
            <a class="active" href="#">
              DE
            </a>
          </li>
          <li>
            <a href="#">EN</a>
          </li>
        </ul>
        <button
          class="btn btn-secondary d-none d-lg-block search-button"
          data-search-icon=""
          type="button"
        >
          <svg height="20" viewBox="0 0 19 20" width="19">
            <g
              fill="none"
              fill-rule="evenodd"
              stroke="currentColor"
              transform="translate(1 1)"
            >
              <path
                d="M16.5 17.5l-4-4"
                stroke-linecap="round"
                stroke-wdth="3"
              ></path>
              <circle cx="7" cy="7" r="7" strokeWidth="2"></circle>
            </g>
          </svg>
          <span class="sr-only sr-only-focusable">Suchen</span>
        </button>
      </div>
    </div>

    <!-- PAAS TITLEBAR -->
    <div class="navbar-banner bg-secondary py-1 w-100">
      <p class="container font-bigger leading-semi">
        PROJECT TITLE
      </p>
    </div>
        
    <div class="paas container">
      <nav class="navbar navbar-light navbar-expand-lg navbar-main">
        <div
          class="collapse navbar-collapse pb-3 pb-lg-0"
          id="navbarTogglerDemo03"
        >
          <ul class="navbar-nav">
            <li class="nav-item">
              <a class="nav-link active" href="#">
                First level 1
              </a>
            </li>
            <li class="nav-item">
              <a class="nav-link" href="#">
                First level 2
              </a>
            </li>
            <li class="nav-item dropdown">
              <a
                class="nav-link dropdown-toggle"
                href="#"
                data-bs-toggle="dropdown"
              >
                First level 3
              </a>
              <ul class="dropdown-menu">
                <li class="nav-item">
                  <a class="dropdown-item" href="#">
                    Second level 1
                  </a>
                </li>
                <li class="nav-item dropdown">
                  <a
                    class="nav-link dropdown-toggle"
                    href="#"
                    data-bs-toggle="dropdown"
                  >
                    Second level 2
                  </a>
                  <ul class="submenu dropdown-menu">
                    <li>
                      <a class="dropdown-item" href="">
                        Third level 1
                      </a>
                    </li>
                    <li>
                      <a class="dropdown-item" href="">
                        Third level 2
                      </a>
                    </li>
                    <li class="nav-item dropdown">
                      <a
                        class="nav-link dropdown-toggle"
                        href=""
                        data-bs-toggle="dropdown"
                      >
                        Third level 3
                      </a>
                      <ul class="submenu dropdown-menu">
                        <li>
                          <a class="dropdown-item" href="">
                            Fourth level 1
                          </a>
                        </li>
                        <li>
                          <a class="dropdown-item" href="">
                            Fourth level 2
                          </a>
                        </li>
                      </ul>
                    </li>
                    <li>
                      <a class="dropdown-item" href="">
                        Second level 4
                      </a>
                    </li>
                    <li>
                      <a class="dropdown-item" href="">
                        Second level 5
                      </a>
                    </li>
                  </ul>
                </li>
                <li>
                  <a class="dropdown-item" href="#">
                    Dropdown item 3
                  </a>
                </li>
                <li>
                  <a class="dropdown-item" href="#">
                    Dropdown item 4
                  </a>
                </li>
              </ul>
            </li>
            <li class="nav-item">
              <a class="nav-link" href="#">
                First level 1
              </a>
            </li>
            <li class="nav-item">
              <a class="nav-link" href="#">
                First level 2
              </a>
            </li>
            <li class="nav-item dropdown">
              <a
                class="nav-link dropdown-toggle"
                href="#"
                data-bs-toggle="dropdown"
              >
                Dropdown right
              </a>
              <ul class="dropdown-menu dropdown-menu-right">
                <li>
                  <a class="dropdown-item" href="#">
                    Dropdown item 1
                  </a>
                </li>
                <li>
                  <a class="dropdown-item" href="#">
                    Dropdown item 2
                  </a>
                </li>
                <li class="nav-item dropdown">
                  <a
                    class="nav-link dropdown-toggle"
                    href="#"
                    data-bs-toggle="dropdown"
                  >
                    Dropdown item 3
                  </a>
                  <ul class="submenu submenu-left dropdown-menu">
                    <li>
                      <a class="dropdown-item" href="">
                        Submenu item 1
                      </a>
                    </li>
                    <li>
                      <a class="dropdown-item" href="">
                        Submenu item 2
                      </a>
                    </li>
                    <li>
                      <a class="dropdown-item" href="">
                        Submenu item 3
                      </a>
                    </li>
                    <li>
                      <a class="dropdown-item" href="">
                        Submenu item 4
                      </a>
                    </li>
                  </ul>
                </li>
                <li>
                  <a class="dropdown-item" href="#">
                    Dropdown item 4
                  </a>
                </li>
              </ul>
            </li>
          </ul>
        <div class="d-lg-none">
          <form
            method="get"
            class="form-control-lg search-form"
            action="https://www.fhnw.ch/plattformen/dokumentation-webdienste/"
            data-search-form=""
          >
            <div class="search-box-wrapper">
              <label htmlFor="63ef28553013c" class="sr-only">
                Geben Sie Ihren Suchbegriff ein
              </label>
              <input
                type="text"
                class="field"
                name="s"
                id="63ef28553013c"
                aria-label="Geben Sie Ihren Suchbegriff ein"
                placeholder="Geben Sie Ihren Suchbegriff ein"
                data-search-input=""
                autoComplete="off"
              />
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="64"
                height="64"
                viewBox="0 0 484.5 484.5"
                class="enter-icon"
                data-search-enter-icon="enter-icon"
              >
                <path d="M433.5 114.75v102H96.9l91.8-91.8-35.7-35.7-153 153 153 153 35.7-35.7-91.8-91.8h387.6v-153z"></path>
              </svg>
              </div>
            </form>
          </div>
        </div>
      </nav>
    </div>
  </nav>

  <footer id="footer">
    <div class="container">
      <div class="row">
        <div class="col-xs-12 col-sm-6 col-md-4">
          <h4>Kontakt</h4>
          <p>
            Fachhochschule Nordwestschweiz FHNW
            <br />
            Institute
            <br />
            Division
            <br />
            Street<br />
            Zip Location
          </p>
          <p>
            E-Mail: <a href="mailto:#">E-Mail</a>
          </p>

          <!-- Social Media Icons -->
          ...
        </div>
        <div class="col-xs-12 col-sm-12 col-md-4 order-first order-md-0">
          <h4>Über diese Website</h4>
          <p>
            Lorem ipsum dolor sit amet, consectetur adipisicing elit. Recusandae vel esse obcaecati minus!
            Aperiam quibusdam, voluptatem est recusandae neque veritatis sunt.
            Corporis quibusdam ad vitae consequuntur nemo, atque error iste.
          </p>
        </div>
        <div class="col-xs-12 col-sm-6 col-md-4">
          <h4>Quicklinks</h4>
          <p>
            <a href="#">
              Link
            </a>
            <br />
            <a href="#">Link</a>
            <br />
            <a href="#">
              Link
            </a>
            <br />
            <a href="#">Quicklinks</a>
          </p>
        </div>
      </div>
    </div>
    <div class="container tools__footer">
      <div class="row">
        <div class="d-flex justify-content-center">
          <p>
            <a href="https://www.fhnw.ch" target="_blank">
              www.fhnw.ch
            </a>
            <span class="d-inline-block mx-1 mx-md-2">|</span>
            <a href="#">Impressum</a>
            <span class="d-inline-block mx-1 mx-md-2">|</span>
            <a href="#">Datenschutz</a>
          </p>
        </div>
      </div>
    </div>
  </footer>
  ...
`;

  return (
    <>
      <ToastHighLighter
        name={'webdiensttemplate'}
        codeString={codeString}
        language={language}
        show={false}
      />
    </>
  );
};
